import { render, staticRenderFns } from "./surveyuser.vue?vue&type=template&id=42addc10&scoped=true&"
import script from "./surveyuser.vue?vue&type=script&lang=js&"
export * from "./surveyuser.vue?vue&type=script&lang=js&"
import style0 from "./surveyuser.vue?vue&type=style&index=0&id=42addc10&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/_vue-loader@15.10.1@vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "42addc10",
  null
  
)

export default component.exports